<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>file_upload</mat-icon>
      Upload Cohorts File
    </h1>
  </section>
  <section mat-dialog-content="">
    @if (!form.get('file')?.value) {
      <div
        (click)="fileInput.click()"
        (onFileDropped)="fileUpload($event)"
        class="upload-file-container"
        dragDropImages
        >
        <input #fileInput (change)="fileUpload($event)" hidden type="file" />
      </div>
    }
    @if (form.get('file')?.value) {
      <div>
        {{form.get("file")?.value?.name}}
        <button (click)="removeFile()" mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Upload data cleanse CSV."
      type="submit"
      >
      <mat-icon>done</mat-icon>
      Done
    </button>
  </section>
</form>
